module.exports = __webpack_public_path__ + "static/media/firestore.bd3c9113.png";